import React, { useState, useEffect, useRef } from 'react';
import { Logo } from '../components/logo';
import UserWidget from '../components/login_in_auth';
import { useTelegramWebApp } from '../hooks/useTelegramWebApp';
import fon from '../components/fon2.png';
import image10 from '../components/4.png';
import { API_BASE } from '../utils/env';
import { getToken } from '../utils/token';
import { useNavigate } from 'react-router-dom';
import { getEmail } from '../utils/token';
import { get } from 'http';


export const AI = () => {
  const navigate = useNavigate();
  const [image, setImage] = useState<string | null>(null);
  const [analysisResult, setAnalysisResult] = useState<string | null>(null);
  const [procent, setProcent] = useState<number | null>(null);
  const [sol, setSol] = useState<'SELL' | 'BUY' | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const resultRef = useRef<HTMLDivElement>(null);
  const uploadZoneRef = useRef<HTMLDivElement>(null);
  const { user } = useTelegramWebApp();
    // контейнер, в котором картинка должна быть «как можно больше»
  const imageBoxStyle: React.CSSProperties = {
    position: 'relative',
    width: '100%',          // или 1181px, как у вас
    height: 400,            // максимальная высота, которую вы ей даёте
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  // стили самой картинки
  const imgStyle: React.CSSProperties = {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',   // вписываем без искажений
  };
  const handleButtonClick = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.onchange = (e) => {
      const file = (e.target as HTMLInputElement).files?.[0];
      if (file) {
        if (!file.type.match('image.*')) {
          alert('Please upload an image file (JPG, PNG, GIF)');
          return;
        }
        if (file.size > 5 * 1024 * 1024) {
          alert('File size exceeds 5MB limit');
          return;
        }
        const reader = new FileReader();
        reader.onload = () => {
          setImage(reader.result as string);
          setAnalysisResult(null);
          setProcent(null);
          setSol(null);
          setError(null);
        };
        reader.readAsDataURL(file);
      }
    };
    input.click();
  };

  const handleZoneClick = () => handleButtonClick();

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const files = e.dataTransfer.files;
    if (files?.[0]) {
      const file = files[0];
      if (!file.type.match('image.*')) {
        alert('Please upload an image file (JPG, PNG, GIF)');
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        alert('File size exceeds 5MB limit');
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result as string);
        setAnalysisResult(null);
        setProcent(null);
        setSol(null);
        setError(null);
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    const handlePaste = (e: Event) => {
      const clipboardData = (e as ClipboardEvent).clipboardData;
      if (!clipboardData) return;
      const items = clipboardData.items;
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          const blob = items[i].getAsFile();
          if (blob) {
            if (blob.size > 5 * 1024 * 1024) {
              alert('Pasted image exceeds 5MB limit');
              return;
            }
            const reader = new FileReader();
            reader.onload = () => {
              setImage(reader.result as string);
              setAnalysisResult(null);
              setProcent(null);
              setSol(null);
              setError(null);
            };
            reader.readAsDataURL(blob);
          }
        }
      }
    };
    window.addEventListener('paste', handlePaste as EventListener);
    return () => window.removeEventListener('paste', handlePaste as EventListener);
  }, []);

  useEffect(() => {
    if (!image) return;
    setIsLoading(true);
    setError(null);

    const analyze = async () => {
      try {
        const res = await fetch(`${API_BASE}/analyze`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(getToken() && { Authorization: `Bearer ${getToken()}` }),
          },
          body: JSON.stringify({
            image,
            email: getEmail(),
          }),
        });
        if (res.status === 401) {
          navigate('/?reason=401');     // ← редирект
          return;                    // прекращаем работу компонента
        }
        if (!res.ok) {
          if (res.status === 429) {
            setAnalysisResult('Активируйте аккаунт');
            setProcent(0);
            setSol(null);
            setIsLoading(false);
            return; // выходим, не выводим техническую ошибку
          }
          else{
          const err = await res.json();
          throw new Error(err.message || 'Server error');
          }
        }
        
        const data = await res.json();
        const cleaned = data.answer
          .replace(/^```json\s*/i, '')
          .replace(/\s*```$/, '');
        let parsed: any;
        try {
          parsed = JSON.parse(cleaned);
        } catch {
          parsed = { text: data.answer, procent: 0, sol: 'BUY' };
        }
        setAnalysisResult(parsed.text ?? 'No description');
        if (parsed.procent === undefined) {
          console.warn('Поле "procent" отсутствует в ответе сервера');
        }
        setProcent(parsed.pocent ?? 0);
        console.log(parsed.sol)
        setSol(parsed.sol === 'BUY' ? 'SELL' : 'BUY');
      } catch (err: any) {
        setError(err.message || 'Failed to analyze');
      } finally {
        setIsLoading(false);
      }
    };
    analyze();
  }, [image]);

  return (
    <div
      style={{
        position: 'relative',
        height: '1700px',
        background: 'linear-gradient(314.56deg, #0A090C 0.38%, #1A092D 99.62%)',
      }}
    >
      <img
        src={image10}
        alt="bg1"
        style={{
          position: 'absolute',
          width: 1404,
          height: 790,
          left: -37,
          top: -202,
          objectFit: 'cover',
          zIndex: 0,
          opacity: 0.2,
          mixBlendMode: 'color-dodge',
        }}
      />
      <img
        src={fon}
        alt="bg2"
        style={{
          position: 'absolute',
          width: 1682,
          height: 946,
          left: -197,
          top: 444,
          objectFit: 'cover',
          zIndex: 0,
          opacity: 0.2,
          mixBlendMode: 'lighten',
        }}
      />
      <Logo />
      <UserWidget />

      <div style={{ position: 'relative', width: 1248, height: 1163 }}>
        <div
          style={{
            position: 'absolute',
            left: 100,
            top: 20,
            width: 1248,
            height: 956,
            borderRadius: 50,
            background: 'rgba(127, 56, 243, 0.15)',
            backdropFilter: 'blur(4.392px)',
            WebkitBackdropFilter: 'blur(4.392px)',
            boxShadow: `
              -10.0354px -9.3528px 43.2px -10.8px rgba(0,0,0,.15),
              -1.67256px -1.5588px 10.8px -7.2px rgba(0,0,0,.15),
              inset 1.80636px 1.6835px 7.776px rgba(255,255,255,.15),
              inset 0.970085px 0.904104px 3.888px rgba(255,255,255,.15)
            `,
          }}
        />

        <div style={{ position: 'absolute', left: 170, top: 45, fontFamily: `'Inter Hewn', sans-serif`, fontWeight: 700, fontSize: 38.4, color: '#fff' }}>
          For<span style={{ color: 'transparent', background: 'linear-gradient(to right, rgb(109, 29, 125), rgb(95, 11, 232))', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Matrix</span>
        </div>
        <div style={{ position: 'absolute', left: 369, top: 45, fontFamily: `'Inter Hewn', sans-serif`, fontWeight: 700, fontSize: 38.4, color: '#fff' }}>Turbo</div>
        <div style={{ position: 'absolute', left: 170, top: 102, width: 313, height: 8, borderRadius: 50, background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)' }} />
        <div style={{ position: 'absolute', left: 170, top: 121, width: 734, fontFamily: `'SF Pro', sans-serif`, fontWeight: 510, fontSize: 24, lineHeight: '29px', color: 'rgba(255, 255, 255, 0.6)' }}>
          High-speed binary options strategy with AI-powered pattern recognition for rapid signals with 1-5 minute expiration times
        </div>
        <div style={{ position: 'absolute', left: 170, top: 281, width: 1119, fontFamily: `'SF Pro', sans-serif`, fontWeight: 510, fontSize: 24, lineHeight: '29px', color: 'rgba(255, 255, 255, 0.6)' }}>
          Upload your charts for AI-powered technical analysis, pattern recognition, and trade recommendations based on proven trading strategies scalp trading
        </div>

        <div style={{ position: 'absolute', left: 170, top: 210, width: 45, height: 45 }}>
          <div style={{ width: 45, height: 45, borderRadius: '50%', background: 'rgba(96, 13, 219, 0.2)', backdropFilter: 'blur(6.064px)' }} />
          <div style={{ position: 'absolute', left: 20, top: 17, width: 6, height: 22, borderRadius: 3, background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)' }} />
          <div style={{ position: 'absolute', left: 19, top: 7, width: 8, height: 8, borderRadius: 3, background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)' }} />
        </div>
        <div style={{ position: 'absolute', left: 240, top: 210, fontFamily: `'SF Pro', sans-serif`, fontWeight: 700, fontSize: 32, color: 'rgba(255, 255, 255, 0.8)' }}>Chart Analysis Information</div>

        <div
          ref={uploadZoneRef}
          onDragOver={handleDragOver}
          onDrop={handleDrop}
          onClick={handleZoneClick}
          style={{ position: 'absolute', left: 133, top: 388, width: 1181, height: 524, cursor: 'pointer' }}
        >
          <div style={{ position: 'absolute', inset: 0, borderRadius: 45, background: 'rgba(127, 56, 243, 0.15)', backdropFilter: 'blur(4.392px)', boxShadow: `...` }} />
          {image ? (
            <div style={{ position: 'absolute', left: '50%', top: 60, transform: 'translateX(-50%)' }}>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  setImage(null);
                  setAnalysisResult(null);
                  setProcent(null);
                  setSol(null);
                  setError(null);
                }}
                style={{ position: 'absolute', right: -10, top: -10, width: 32, height: 32, borderRadius: '50%', background: 'rgba(0,0,0,.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', zIndex: 10 }}
                title="Remove image"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M12 4L4 12M4 4l8 8" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </div>
              <img src={image} alt="chart" style={{ maxWidth: '90%', maxHeight: 400, objectFit: 'contain' }} />
            </div>
          ) : (
            <>
              <svg width="93" height="90" viewBox="0 0 93 90" fill="none" style={{ position: 'absolute', zIndex: 20, left: 550, top: 50 }}>
                <path d="M12.2502 89.1666C9.11058 89.1666..." fill="url(#paint0_linear_31_524)" />
                <defs>
                  <linearGradient id="paint0_linear_31_524" x1="0.833496" y1="44.713" x2="92.1669" y2="44.713" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#6D1D7D" />
                    <stop offset="1" stopColor="#5F0BE8" />
                  </linearGradient>
                </defs>
              </svg>
              <div style={{ position: 'absolute', left: '50%', top: 165, transform: 'translateX(-50%)', fontFamily: `'SF Pro', sans-serif`, fontWeight: 700, fontSize: 38.4, color: '#fff' }}>Upload Chart Image</div>
              <div style={{ position: 'absolute', left: '50%', top: 223, transform: 'translateX(-50%)', fontFamily: `'SF Pro', sans-serif`, fontWeight: 510, fontSize: 24, color: 'rgba(255, 255, 255, 0.6)' }}>Drag & drop your trading chart screenshot here, or click to browse</div>
              <div style={{ position: 'absolute', left: '50%', top: 272, transform: 'translateX(-50%)', fontFamily: `'SF Pro', sans-serif`, fontWeight: 510, fontSize: 22, color: 'rgba(255, 255, 255, 0.4)' }}>Tip: You can also paste (Ctrl+V) a copied image!</div>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  handleButtonClick();
                }}
                style={{
                  position: 'absolute',
                  left: '50%',
                  top: 346,
                  transform: 'translateX(-50%)',
                  width: 323,
                  height: 69,
                  borderRadius: 34.6368,
                  background: 'linear-gradient(90deg, rgba(109, 29, 125, 0.8) 0%, rgba(95, 11, 232, 0.8) 100%)',
                  boxShadow: `...`,
                  backdropFilter: 'blur(1.6896px)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                }}
              >
                <span style={{ fontFamily: `'SF Pro', sans-serif`, fontWeight: 510, fontSize: 32.4403, color: '#fff' }}>Select Image</span>
              </div>
              <div style={{ position: 'absolute', left: '50%', top: 445, transform: 'translateX(-50%)', fontFamily: `'SF Pro', sans-serif`, fontWeight: 510, fontSize: 18, color: 'rgba(255, 255, 255, 0.4)' }}>Supported formats: JPG, PNG, GIF • Max size: 5MB</div>
            </>
          )}
        </div>

        {(analysisResult || isLoading || error) && (
          <div
            ref={resultRef}
            style={{
              position: 'absolute',
              width: 1181,
              left: 133,
              top: 1020,
              background: 'rgba(127, 56, 243, 0.2)',
              backdropFilter: 'blur(4.88px)',
              borderRadius: 50,
              padding: '32px 40px',
              minHeight: 483,
              boxSizing: 'border-box',
            }}
          >
            {isLoading ? (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <div style={{ width: 60, height: 60, border: '5px solid rgba(255,255,255,.1)', borderRadius: '50%', borderTop: '5px solid #5F0BE8', animation: 'spin 1s linear infinite', marginBottom: 24 }} />
                <style>{`@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}`}</style>
                <div style={{ fontFamily: `'SF Pro', sans-serif`, fontWeight: 510, fontSize: 24, color: '#fff' }}>Analyzing your chart...</div>
                <div style={{ fontFamily: `'SF Pro', sans-serif`, fontWeight: 400, fontSize: 18, color: 'rgba(255,255,255,0.6)', marginTop: 12 }}>This usually takes about 1-2 seconds</div>
              </div>
            ) : error ? (
              <div style={{ fontFamily: `'SF Pro', sans-serif`, fontWeight: 510, fontSize: 24, color: '#FF4444', textAlign: 'center' }}>{error}</div>
            ) : (
              <>
                {procent !== null && sol && (
                  <div
                    style={{
                      position: 'absolute',
                      left: 504,
                      top: 10,
                      width: 240,
                      height: 69,
                      background: sol === 'SELL' ? 'linear-gradient(90deg, rgba(18, 121, 97, 0.8) 0%, rgba(2, 217, 174, 0.8) 100%)' : 'linear-gradient(90deg, rgba(125, 29, 112, 0.8) 0%, rgba(232, 11, 107, 0.8) 100%)',
                      mixBlendMode: 'normal',
                      boxShadow: `
                        -9.41986px -8.77916px 40.5504px -10.1376px rgba(0,0,0,.15),
                        -1.56998px -1.46319px 10.1376px -6.7584px rgba(0,0,0,.15),
                        inset 1.56998px 1.46319px 6.7584px rgba(255,255,255,.15),
                        inset 0.784988px 0.731597px 3.3792px rgba(255,255,255,.15)
                      `,
                      backdropFilter: 'blur(1.6896px)',
                      borderRadius: '34.6368px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 12,
                    }}
                  >
                    <svg width="44" height="27" viewBox="0 0 44 27" fill="none" xmlns="http://www.w3.org/2000/svg" style={{transform: sol === 'SELL' ? 'scaleY(-1)' : 'scaleY(1)',transition: 'transform 0.2s ease',}}>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.49018 0.941966C5.19154 0.643326 4.837 0.406432 4.44681 0.244809C4.05662 0.0831862 3.63841 0 3.21607 0C2.36312 0 1.5451 0.338835 0.941966 0.941966C0.338835 1.5451 0 2.36312 0 3.21607C0 4.06903 0.338835 4.88705 0.941966 5.49018L11.6552 16.2002L11.6777 16.2227C12.553 17.08 13.7294 17.5602 14.9546 17.5602C16.1799 17.5602 17.3563 17.08 18.2316 16.2227L18.2541 16.2002L23.7216 10.7327L31.2655 18.7105L27.9227 22.0534C27.586 22.3905 27.3567 22.8199 27.2639 23.2872C27.171 23.7546 27.2188 24.239 27.401 24.6792C27.5833 25.1195 27.892 25.4958 28.288 25.7607C28.6841 26.0257 29.1498 26.1673 29.6262 26.1677H41.368C42.0074 26.1677 42.6206 25.9137 43.0727 25.4616C43.5248 25.0095 43.7788 24.3963 43.7788 23.757V12.0248C43.7783 11.5483 43.6367 11.0827 43.3718 10.6866C43.1069 10.2906 42.7305 9.9819 42.2903 9.79962C41.8501 9.61733 41.3657 9.56959 40.8983 9.66244C40.431 9.75528 40.0016 9.98454 39.6645 10.3213L35.8137 14.1688L27.1223 4.9759L27.0355 4.88589C26.1601 4.02761 24.983 3.54685 23.757 3.54685C22.531 3.54685 21.3539 4.02761 20.4784 4.88589L20.4591 4.90839L14.953 10.4113L5.49018 0.941966Z" fill="white"/>
                    </svg>

                    <span style={{ fontFamily: `'SF Pro', sans-serif`, fontWeight: 600, fontSize: 24, color: '#fff' }}>
                      {procent}%
                    </span>
                  </div>
                )}

                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    minHeight: 300,
                    fontFamily: `'SF Pro', sans-serif`,
                    fontWeight: 510,
                    fontSize: 24,
                    color: '#fff',
                    lineHeight: '32px',
                    textAlign: 'center',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                  }}
                >
                  {analysisResult}
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};